import { ChipColor } from '@/components/chip/helpers';

export type AuditLogActor = {
  userId: string;
  orgId: string;
  name: string;
  email: string;
};

export type AuditLogMeta = {
  id: string;
  eventDateTime: string;
  eventType: string;
  name: string;
};

export const AuditLogActions: Map<string, { label: string; color: ChipColor }> = new Map([
  ['create', { label: 'create', color: 'success' }],
  ['read', { label: 'read', color: 'primary' }],
  ['update', { label: 'update', color: 'warning' }],
  ['delete', { label: 'delete', color: 'error' }],
  ['bulk-delete', { label: 'bulk delete', color: 'error' }],
  ['other', { label: 'other', color: 'default' }],
  ['upload', { label: 'upload', color: 'success' }],
  ['download', { label: 'download', color: 'secondary' }],
  ['export', { label: 'export', color: 'secondary' }],
  ['apply', { label: 'apply', color: 'warning' }],
]);
